import React, { useContext } from 'react'
import Router, { useRouter } from 'next/router'

import { DOMAINS } from 'utils/Constants'
import { HomePageSEO } from 'components/SEO/HomePageSEO'
import CCAMainContainer from 'components/CCA/CCAMainContainer'
import MainContainer from 'components/MainContainer'
import useAnalyticsPageTracker from 'hooks/useAnalyticsPageTracker'
import { AppContext } from '../contexts/AppContext'

const HomePageSwitch = ({ domain, pageProps }) => {
  const { CHILD_CARE_ADVANTAGE } = DOMAINS
  switch (domain) {
    case CHILD_CARE_ADVANTAGE:
      return <CCAMainContainer {...pageProps} />
    default:
      return <MainContainer {...pageProps} />
  }
}

const Index = (props) => {
  const router = useRouter()
  const { domain } = useContext(AppContext)
  useAnalyticsPageTracker('home', router.asPath)

  const { pageProps, metaDescription, title, loggedIn } = props

  if (loggedIn) {
    if (process.browser) {
      Router.push('/homepage')
    }
    return null
  }

  return (
    <>
      <HomePageSEO metaDescription={metaDescription} title={title} domain={domain} />
      <HomePageSwitch domain={domain} pageProps={pageProps} />
    </>
  )
}
export default Index
